export default __webpack_public_path__ + "static/media/software-image-01.4567a4cd.png";